import { projectTimeSheet, timeSheet } from "@planzone/dto";
import { Selector, State } from "./types";
import { matchRequest } from "./utils";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveProjectTimeSheetRequestFailure(project, filter, size) {
      const req = getState().find((req) =>
        matchRequest(req, project, filter, size),
      );

      return req ? req.request.isFailure : false;
    },
    isRetrieveProjectTimeSheetRequestPending(project, filter, size) {
      const req = getState().find((req) =>
        matchRequest(req, project, filter, size),
      );

      return req ? req.request.isPending : false;
    },
    isRetrieveProjectTimeSheetRequestSuccess(project, filter, size) {
      const req = getState().find((req) =>
        matchRequest(req, project, filter, size),
      );

      return req ? req.request.isSuccessful : false;
    },
    isProjectTimeSheetDirty(project, filter, size) {
      const req = getState().find((req) =>
        matchRequest(req, project, filter, size),
      );

      return req ? req.isDirty : false;
    },
    getProjectTimeSheet(project, filter, size) {
      const req = getState().find((req) =>
        matchRequest(req, project, filter, size),
      );

      return req ? req.timeSheet : projectTimeSheet;
    },
    getProjectTimeSheetCurrentPage(project, filter, size) {
      const req = getState().find((req) =>
        matchRequest(req, project, filter, size),
      );

      return req ? req.page : 0;
    },
    canLoadMoreProjectTimeSheet(project, filter, size) {
      const req = getState().find((req) =>
        matchRequest(req, project, filter, size),
      );

      return req ? req.canLoadMore : true;
    },
  };
}

export { createSelector };
